import { render, staticRenderFns } from "./kiosk_check_in_settings.vue?vue&type=template&id=142ef5ae&"
import script from "./kiosk_check_in_settings.vue?vue&type=script&lang=js&"
export * from "./kiosk_check_in_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports